import { styled } from 'goober';
import { FeedbackRequestStatus } from '@shared/model/feedback-request';
import {
    FEEDBACK_REQUEST_TEXT_COLOR_STATUS_MAP,
    FEEDBACK_REQUEST_BACKGROUND_COLOR_STATUS_MAP,
} from '@entities/feedback-request/config/ui-constants';
import { COLORS } from '@shared/config/colors/colors';

export const Wrapper = styled('div')<{ $status: FeedbackRequestStatus }>(({ $status }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
    gap: '4px',
    padding: '4px 8px',
    borderRadius: '16px',
    color: COLORS[FEEDBACK_REQUEST_TEXT_COLOR_STATUS_MAP[$status]],
    backgroundColor: COLORS[FEEDBACK_REQUEST_BACKGROUND_COLOR_STATUS_MAP[$status]],
}));
